import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import PianoContiService from 'services/PianoContiService';

export const initialState = {
    loadingPianoConti: false,
    loadedPianoConti: false,
    conti: [],
    errorPianoConti: false,
    loadingInizializza: false,
};

export const loadPianoConti = createAsyncThunk('piano-conti/load', async (companyDocumentId, { rejectWithValue }) => {
    try {
        const response = await PianoContiService.getAll(companyDocumentId);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

export const createConto = createAsyncThunk('piano-conti/create', async (data, { rejectWithValue }) => {
    try {
        const response = await PianoContiService.create(data);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

export const updateConto = createAsyncThunk('piano-conti/update', async ({ documentId, data }, { rejectWithValue }) => {
    try {
        const response = await PianoContiService.update(documentId, data);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

export const inizializzaContiDefault = createAsyncThunk('piano-conti/inizializza', async (companyDocumentId, { rejectWithValue }) => {
    try {
        const response = await PianoContiService.inizializzaDefault(companyDocumentId);
        return response;
    } catch (err) {
        return rejectWithValue(err?.response?.data || err.message);
    }
});

const pianoContiSlice = createSlice({
    name: 'pianoConti',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // load
            .addCase(loadPianoConti.pending, (state) => {
                state.loadingPianoConti = true;
                state.errorPianoConti = false;
            })
            .addCase(loadPianoConti.fulfilled, (state, action) => {
                state.loadingPianoConti = false;
                state.loadedPianoConti = true;
                state.conti = action.payload || [];
            })
            .addCase(loadPianoConti.rejected, (state) => {
                state.loadingPianoConti = false;
                state.loadedPianoConti = true;
                state.errorPianoConti = true;
                message.error('Errore nel caricamento del piano dei conti');
            })
            // create
            .addCase(createConto.fulfilled, (state, action) => {
                state.conti = [...state.conti, action.payload];
                message.success('Conto creato con successo');
            })
            .addCase(createConto.rejected, () => {
                message.error('Errore nella creazione del conto');
            })
            // update
            .addCase(updateConto.fulfilled, (state, action) => {
                const idx = state.conti.findIndex((c) => c.documentId === action.payload.documentId);
                if (idx !== -1) {
                    state.conti[idx] = action.payload;
                }
                message.success('Conto aggiornato con successo');
            })
            .addCase(updateConto.rejected, () => {
                message.error('Errore nell\'aggiornamento del conto');
            })
            // inizializza default
            .addCase(inizializzaContiDefault.pending, (state) => {
                state.loadingInizializza = true;
            })
            .addCase(inizializzaContiDefault.fulfilled, (state) => {
                state.loadingInizializza = false;
                state.loadedPianoConti = false; // forza reload
                message.success('Piano dei conti inizializzato con i conti di default');
            })
            .addCase(inizializzaContiDefault.rejected, (state, action) => {
                state.loadingInizializza = false;
                const msg = action.payload?.error?.message || 'Errore nell\'inizializzazione';
                message.error(msg);
            });
    },
});

export default pianoContiSlice.reducer;
